import React from 'react'

const Dropdown = ({ children }) => (
  <div className="relative inline-block min-w-[150px] w-full">
    {children}
    <span className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2">
      <svg width="16" height="10" viewBox="0 0 16 10" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M3 3l5 5 5-5" stroke="#666" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    </span>
  </div>
)

export default Dropdown
